// // src/contexts/ConfigContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from 'axios';
import { fetchWithRetry } from "../utils/fetchWithRetry";
import { Helmet } from "react-helmet";


const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [logo, setLogo] = useState(null);
  const [config, setConfig] = useState([]);
  const [configLoading, setLoadingConfig] = useState(false);
  const [configError, setErrorConfig] = useState(null);

  const CONFIG_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Konfiguration';

  useEffect(() => {
    const ac = new AbortController();
    const fetchConfig = async () => {
      setLoadingConfig(true); setErrorConfig(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(CONFIG_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        console.log(res);
        setConfig(res?.data?.data ?? []);
        setLogo(process.env.REACT_APP_API_BASE_URL + '/assets/' + res?.data?.data.Logo);
      } catch (e) {
        if (!ac.signal.aborted) setErrorConfig('Error');
      } finally {
        if (!ac.signal.aborted) setLoadingConfig(false);
      }
    };
    fetchConfig();
    /* return () => ac.abort(); */
  }, []);

  return (
    <ConfigContext value={{ logo, config, configLoading, configError }}>
      {/* <Helmet> */}
        <style type="text/css">
          {`
            :root {
              --primary: ${config.Primaerfarbe};
              --accent: ${config.Akzentfarbe};
            }
          `}
        </style>
      {/* </Helmet> */}
      {console.log(logo)}
      {children}
    </ConfigContext>
  );
};

export const useConfig = () => useContext(ConfigContext);
